// extracted by mini-css-extract-plugin
module.exports = {"root":"TripCartForm_root__UldVz"};